import { useMemo } from "react";
import ServerSideDataTable from "./ServerSideDataTable";
import { getCars } from "../api";

const DEFAULT_SORT_BY = "id";
const DEFAULT_SORT_INDEX = 0;

function CarsDataTable() {
    const columns = useMemo(() => [
        { data: "id", title: "ID" },
        {
            data: "brand",
            title: "Marque",
            render: (data) => data || "-"
        },
        {
            data: "model",
            title: "Modèle",
            render: (data) => data || "-"
        },
        {
            data: "year",
            title: "Année",
            render: (data) => data || "-"
        },
        {
            data: "color",
            title: "Couleur",
            render: (data) => data || "-"
        },
        {
            data: "mileage",
            title: "Kilométrage",
            render: (data) => Number.isFinite(Number(data)) ? Number(data).toLocaleString() : (data || "-")
        }
    ], []);

    return (
        <ServerSideDataTable
            columns={columns}
            defaultSortBy={DEFAULT_SORT_BY}
            defaultSortIndex={DEFAULT_SORT_INDEX}
            errorMessage="Impossible de charger les véhicules pour l'instant."
            fetchPage={(token, query) => getCars(token, query.page, query.pageSize, {
                q: query.q,
                sortBy: query.sortBy,
                sortDir: query.sortDir
            })}
        />
    );
}

export default CarsDataTable;
